(function(){
    'use strict';

    var anchors = $(".icons__anchor");

    function scrollDown(e){
        e.preventDefault();
        var elScroll = $($(this).attr("href"));

        if(elScroll.length > 0){
             $('html, body').animate({
                scrollTop: elScroll.offset().top - 65
            }, 500);
        }
    }

    if(anchors.length > 0){
        anchors.on("click", scrollDown);
    }


})();

(function(){
    'use strict';

    var tab                = $(".corner__tab");
    var tabElements        = $(".corner__tab__element", tab);
    var tabContent         = $(".corner__tab_content");
    var tabContentElements = $(".corner__tab_content_element", tabContent);

    function changeTab(e){
        var index = $(this).index() + 1;

        tabElements.removeClass("corner__tab__element_active");
        tabContentElements.removeClass("corner__tab_content_element_active");

        $(this).addClass("corner__tab__element_active");
        $(".corner__tab_content_" + index).addClass("corner__tab_content_element_active");
    }

    tabElements.on("click", changeTab);

})();
(function(){
    'use strict';

    var tableTeam = $("#table__team");

    function hoverActive(){
        var _self = $(this);

        setTimeout(function(){
            $(".table__team__content",_self).addClass("active");

        }, 200);
    }

    function hoverInactive(){
        $(".table__team__content", $(this)).removeClass("active");

   }

    if(tableTeam.length > 0){
""
        $(".table__team__element", tableTeam).on("mouseenter", hoverActive);
        $(".table__team__element", tableTeam).on("mouseleave", hoverInactive);
    }

})();

//# sourceMappingURL=pro.js.map
